module.exports = __webpack_public_path__ + "16b267014803af32c9add8d4a097bd6f.svg";